import { render, staticRenderFns } from "./RadiobuttonQuestion.vue?vue&type=template&id=e16d1dce&"
import script from "./RadiobuttonQuestion.vue?vue&type=script&lang=js&"
export * from "./RadiobuttonQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports